module.exports = __webpack_public_path__ + "img/yjyl.2e585140.svg";